import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Divider, Grid, IconButton, InputAdornment, Typography } from "@mui/material";
import ComponentApi, { Bookmark } from 'api/components-api';
import TreatmentApi from "api/dentists/treatment.api";
import ClinicApi from 'api/master/clinic.api';
import TemplateTypeApi from 'api/setting/treatment-templates/template-tpyes.api';
import { setTreatmentByKey, treatment, TreatmentStateInterface } from 'app/slice/treatment.slice';
import { selectMe } from 'app/slice/user.slice';
import InputCheckbox from "component/Input/InputCheckbox";
import Loading from 'component/Loading';
import { notiError, notiSuccess } from 'component/notifications/notifications';
import { CustomCollapse } from "component/Register/style/styleTreatmentHistory";
import TableCustom from "component/Table/TableCustom";
import TableRowCommon from 'component/Table/TableRowCommon';
import { ButtonType, CardInfo, Detail, NavBtn } from "component/Treatments/PopupCreateByUsers";
import { icons, Icons } from "constants/images";
import { colors } from "constants/theme";
import { IconBookmark } from "features/treatments/MainMenu/OPD/style/UseStyle";
import { updateDFValue } from 'features/treatments/SummaryTreatment/SummaryTreatment';
import { DoctorsType } from 'features/treatments/treatmentsIndex';
import _ from "lodash";
import TextInput from "new-components/inputs/text-input";
import AlertModal from 'new-components/modal/alert-modal';
import PageModal from "new-components/modal/page-modal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { numberFormat } from 'utils/app.utils';
interface TemplateAllProps {
    setIsOpenModal: any
}
export default function TemplateAll(props: TemplateAllProps) {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const user = useSelector(selectMe)
    const treatments: TreatmentStateInterface = useSelector(treatment)

    const [searchSelectTemplate, setSearchSelectTemplate] = useState('')
    const [typeSelected, setTypeSelected] = useState('All')
    const [treatmentTemplateType, setTreatmentTemplateType] = useState<any>([])
    const [treatmentTemplate, setTreatmentTemplate] = useState<any>([])
    const [isBookmark, setIsBookmark] = useState('0')
    const [typeId, setTypeId] = useState(0)
    const [opens, setOpens]: any[] = useState([]);
    const [templateList, setTemplateList] = useState<any>([])
    const [diagnosisList, setDiagnosisList] = useState<any>([])
    const [checkedTemplates, setCheckedTemplates] = useState<number[]>([]);
    const [activeTabModal, setActiveTabModal] = useState('TREATMENT')
    const [isOpenCheckDuplicate, setIsOpenCheckDuplicate] = useState(false)
    const [isOpenCheckError, setIsOpenCheckError] = useState(false)
    const [loading, setLoading] = useState(false)
    const [doctors, setDoctors] = useState<DoctorsType[]>([])
    const [loadingPage, setLoadingPage] = useState(false)

    const loadDoctor = async () => {
        const resp = await ClinicApi.findAllDoctors()
        if (resp.status === 200) setDoctors(resp.data)
    }

    const loadTemplate = async () => {
        setLoading(true)
        await TreatmentApi.findAllTreatmentTemplates({ page: 1, pageLimit: 100, type: typeId === 0 ? '' : typeId, search: searchSelectTemplate, isBookmark: isBookmark }).then((resp) => {
            setLoading(false)
            setTreatmentTemplate(resp.data)
        }).catch(() => {
            setLoading(false)
            notiError(t('ERROR'))
        })
    }

    const loadTemplateType = async () => {
        await TemplateTypeApi.findAll({ page: 1, pageLimit: 100, status: "ACTIVE" }).then((resp) => {
            setTreatmentTemplateType(resp.data)
        }).catch(() => notiError(t('ERROR')))
    }

    useEffect(() => {
        loadTemplate()
    }, [typeId, searchSelectTemplate, isBookmark])

    useEffect(() => {
        loadTemplateType()
        loadDoctor()
    }, [])

    const handleChangeType = (ele: any) => {
        const type = ele.currentTarget.getAttribute('data-value')
        setTypeSelected(type)
        setIsBookmark('0')
        setTypeId(0)
        if (type === 'BOOKMARK') setIsBookmark('1')
        else {
            setTypeId(parseInt(type) ? type : 0)
        }
    }

    const handleBookmark = async (id: number, bookmarkId: number) => {
        const payload: Bookmark = {
            bookmarkType: 'TREATMENT_TEMPLATE',
            userId: user.userId,
            itemId: id,
            isBookmark: bookmarkId ? '0' : '1'
        }
        const resp = await ComponentApi.bookmark(payload)
        if (resp.status === 201) {
            loadTemplate()
        }
    }

    const headCellTemplate = [
        { id: 'no', disablePadding: false, label: t('TABLE.NO') },
        { id: 'name', disablePadding: false, label: t('ชื่อเทมเพลต') },
        { id: 'code', disablePadding: false, label: t('รหัส') },
        { id: 'list', disablePadding: false, label: t('รายการ/บริการ'), width: '300px' },
        { id: 'qty', disablePadding: false, align: 'center', label: t('จำนวน') },
        { id: 'price', disablePadding: false, label: t('ราคา/หน่วย') },
        { id: 'price', disablePadding: false, label: t('ราคารวม') },
        { id: 'action', disablePadding: false, label: t('Action') },
    ]

    const renderTemplate = (data: any, no: number) => {
        const dataInfo = JSON.parse(data?.itemInfo)
        const objRenderData = {
            key: no + 1,
            id: no.toString(),
            obj: data,
            columns: [
                { option: 'TEXT', align: 'center', label: no + 1, class: 'text-nowrap' },
                { option: 'TEXT', align: 'left', label: data?.templateName || '-' },
                { option: 'TEXT', align: 'left', label: data?.itemCode || '-', class: 'text-nowrap' },
                {
                    option: 'COMPONENT', align: 'left', component: (
                        <Box display='flex' flexDirection="column">
                            <Typography> {data?.itemName}</Typography>
                            {data?.type === 'MEDICINE' && dataInfo &&
                                <>
                                    <Typography>{dataInfo?.productInstructionName} {dataInfo?.dosage} {dataInfo?.productUnitName} {dataInfo?.productUseDetail}</Typography>
                                    <Typography>{dataInfo?.productSymptomDetail && dataInfo?.productWarningDetail ? `${dataInfo?.productSymptomDetail}/${dataInfo?.productWarningDetail}` : `${dataInfo?.productSymptomDetail} ${dataInfo?.productWarningDetail}`}</Typography>
                                </>
                            }
                            {data?.type === 'OPERATIVE' &&
                                <Box display="flex" flexDirection="row" alignItems="center" gap="4px" color="#B00020">
                                    {data?.status === 'INACTIVE' &&
                                        <>
                                            <ErrorOutlineIcon sx={{ fontSize: 13 }} />
                                            <Typography fontSize={12}>{'ถูกปิดการใช้งาน'}</Typography>
                                        </>
                                    }
                                </Box>
                            }
                            {data?.type !== "OPERATIVE" &&
                                <Box display="flex" flexDirection="row" alignItems="center" gap="4px" color="#B00020">
                                    {(data?.status === 'INACTIVE' || data?.qtyTotal <= 0 || !data?.qtyTotal || data?.qty > data?.qtyTotal) &&
                                        <>
                                            <ErrorOutlineIcon sx={{ fontSize: 13 }} />
                                            <Typography fontSize={12}>{data?.status === 'INACTIVE' ? 'ถูกปิดการใช้งาน' : (data?.qtyTotal <= 0 || !data?.qtyTotal || data?.qty > data?.qtyTotal) ? 'สต็อกไม่เพียงพอ' : ''}</Typography>
                                        </>
                                    }
                                </Box>
                            }

                        </Box>
                    )
                    , class: 'bg-white'
                },
                { option: 'TEXT', align: 'center', label: data?.qty, class: 'text-nowrap' },
                { option: 'TEXT', align: 'right', label: `${numberFormat(data?.price)} / ${data?.itemUnitName || '-'}` || '-', class: 'text-nowrap' },
                { option: 'TEXT', align: 'right', label: numberFormat(data?.price * data?.qty) || 0, class: 'text-nowrap' },
                {
                    option: 'COMPONENT',
                    component: (
                        <Box sx={{ height: '43px', textAlign: 'center' }} >
                            <IconButton onClick={() => handleDeleteItem(data, 'TREATMENT')} >
                                <img src={icons.btnTrash} alt="trash" />
                            </IconButton>
                        </Box>
                    )
                },

            ]
        }

        return <TableRowCommon {...objRenderData} />
    }

    const headCellDiagnosis = [
        { id: 'no', disablePadding: false, label: t('TABLE.NO'), width: '5%' },
        { id: 'name', disablePadding: false, label: t('ชื่อเทมเพลต'), width: '30%' },
        { id: 'code', disablePadding: false, label: t('รหัส'), width: '10%' },
        { id: 'list', disablePadding: false, label: t('คำวินิจฉัย'), width: '50%' },
        { id: 'action', disablePadding: false, label: t('Action'), width: '5%' },
    ]

    const renderDiagnosis = (data: any, no: number) => {
        const objRenderData = {
            key: no + 1,
            id: no.toString(),
            obj: data,
            columns: [
                { option: 'TEXT', align: 'center', label: no + 1, class: 'text-nowrap' },
                { option: 'TEXT', align: 'left', label: data?.templateName || '-' },
                { option: 'TEXT', align: 'left', label: data?.itemCode || '-', class: 'text-nowrap' },
                {
                    option: 'COMPONENT', align: 'left', component: (
                        <Box display='flex' flexDirection="column">
                            <Typography> {data?.itemName}</Typography>
                            <Box display="flex" flexDirection="row" alignItems="center" gap="4px" color="#B00020">
                                {data?.status === 'INACTIVE' &&
                                    <>
                                        <ErrorOutlineIcon sx={{ fontSize: 13 }} />
                                        <Typography fontSize={12}>{'ถูกปิดการใช้งาน'}</Typography>
                                    </>
                                }
                            </Box>
                        </Box>
                    ), class: 'text-nowrap'
                },
                {
                    option: 'COMPONENT',
                    component: (
                        <Box sx={{ height: '43px', textAlign: 'center' }} >
                            <IconButton onClick={() => handleDeleteItem(data, 'DIAGNOSIS')} >
                                <img src={icons.btnTrash} alt="trash" />
                            </IconButton>
                        </Box>
                    )
                },
            ]
        }
        return <TableRowCommon {...objRenderData} />
    }

    const handleDeleteItem = (data: any, type: string) => {
        let updatedTemplateList = templateList;
        let updatedDiagnosisList = diagnosisList;

        if (type === "TREATMENT") {
            updatedTemplateList = templateList.filter((item: any) => item.itemId !== data.itemId);
            setTemplateList(updatedTemplateList);
        }

        if (type === "DIAGNOSIS") {
            updatedDiagnosisList = diagnosisList.filter((item: any) => item.itemId !== data.itemId);
            setDiagnosisList(updatedDiagnosisList);
        }

        // อัปเดต checkedTemplates โดยรวมทั้ง template และ diagnosis
        const remainingIds: any[] = [
            ...updatedTemplateList.map((i: any) => i.treatmentTemplateId),
            ...updatedDiagnosisList.map((i: any) => i.treatmentTemplateId)
        ];

        setCheckedTemplates(prev => prev.filter(id => remainingIds.includes(id)));
    };



    const onSubmit = async () => {
        if (templateList?.length === 0 && diagnosisList?.length === 0) {
            notiError('กรุณาเลือกเทมเพลต')
            return
        }

        const templateDuplicate = treatments.summeryTreatments.some((treatment: any) =>
            templateList.some((template: any) =>
                template.type === "OPERATIVE"
                    ? treatment.operativeId === template.itemId
                    : treatment.itemId === template.itemId
            )
        );
        const diagnosisDuplicate = treatments.patientDiagnosis.some((treatment: any) =>
            diagnosisList.some((template: any) => treatment.diagnosisId === template.itemId)
        );

        const hasInvalidTemplate = templateList.some((item: any) => {
            const isInactive = item.status === "INACTIVE";
            const isOutOfStock = item.qtyTotal <= 0 || !item?.qtyTotal || item?.qty > item?.qtyTotal;
            if (item.type === "OPERATIVE") {
                return isInactive;
            } else {
                return isInactive || isOutOfStock;
            }
        });

        const hasInvalidDiagnosis = diagnosisList.some((item: any) => {
            const isInactive = item.status === "INACTIVE";
            return isInactive;
        });

        if (hasInvalidTemplate || hasInvalidDiagnosis) {
            setIsOpenCheckError(true)
            return
        }

        if (templateDuplicate || diagnosisDuplicate) {
            setIsOpenCheckDuplicate(true)
            return
        }

        if (treatments.summeryTreatments?.length > 0 || treatments.patientDiagnosis?.length > 0) {
            setIsOpenCheckDuplicate(true)
        } else {
            dispatch(setTreatmentByKey({ key: 'patientDiagnosis', value: diagnosisList }))
            setLoadingPage(true)
            await updateAllDFValues()
            setLoadingPage(false)
            notiSuccess('ใช้เทมเพลตสำเร็จ')
            props.setIsOpenModal(false)
            setIsOpenCheckDuplicate(false)
            setIsOpenCheckError(false)
        }


    }

    const updateAllDFValues = async () => {
        // copy array ก่อน (ป้องกันการ mutate state ตรง ๆ)
        const lists = [...templateList];
        for (let i = 0; i < lists.length; i++) {
            const item = lists[i];

            // ยิง API ทีละตัว
            const updateDF = await updateDFValue({
                ...item,
                doctorId: user?.userId,
                hasNoDf: false
            });

            if (updateDF) {
                lists[i] = {
                    ...lists[i],
                    doctorId: user?.userId,
                    total: updateDF.total,
                    dfAmount: updateDF.dfAmount,
                    dfUnit: updateDF.dfUnit,
                    cfAmount: updateDF.cfAmount,
                    dfAmountNet: updateDF.dfAmountNet,
                    cfAmountNet: updateDF.cfAmountNet,
                    doctorFeeAmount: updateDF.dfAmount,
                    clinicFeeAmount: updateDF.cfAmount,
                    promotionDiscount: updateDF.promotionDiscount,
                    dfPromotionDiscountAmount: updateDF.dfPromotionDiscountAmount,
                    cfPromotionDiscountAmount: updateDF.cfPromotionDiscountAmount,
                    voucherDiscount: updateDF.voucherDiscount,
                    dfVoucherDiscountAmount: updateDF.dfVoucherDiscountAmount,
                    cfVoucherDiscountAmount: updateDF.cfVoucherDiscountAmount,
                };
            }
        }
        // อัพเดทกลับเข้า Redux
        dispatch(
            setTreatmentByKey({
                key: "summeryTreatments",
                value: lists
            })
        );
    };

    return (
        <>
            <AlertModal
                isOpen={isOpenCheckDuplicate}
                title='พบรายการ/บริการในสรุปการรักษาปัจจุบัน'
                message={`การใช้เทมเพลตนี้จะลบและแทนที่ข้อมูลทั้งหมด\nต้องการดำเนินการต่อใช่หรือไม่?`}
                type='warning'
                handleClose={() => {
                    setIsOpenCheckDuplicate(false)
                }}
                onCancel={{
                    onClick: () => {
                        setIsOpenCheckDuplicate(false)
                    }
                }}
                onSubmit={{
                    onClick: async () => {
                        dispatch(setTreatmentByKey({ key: 'patientDiagnosis', value: diagnosisList }))
                        setIsOpenCheckDuplicate(false)
                        setLoadingPage(true)
                        await updateAllDFValues()
                        setLoadingPage(false)
                        props.setIsOpenModal(false)
                        notiSuccess('ใช้เทมเพลตสำเร็จ')
                    }, title: 'ยืนยัน'
                }}
            />
            <AlertModal
                isOpen={isOpenCheckError}
                title='ไม่สามารถใช้งานเทมเพลตได้'
                message={`เนื่องจากมีบางรายการในเทมเพลตที่ไม่สามารถใช้งานได้\nเช่น รายการถูกปิดการใช้งาน หรือสต๊อกไม่เพียงพอ`}
                type='error'
                handleClose={() => setIsOpenCheckError(false)}
                onCancel={{ onClick: () => setIsOpenCheckError(false), title: 'รับทราบ' }}
                onSubmit={{ onClick: () => null }}
                onCloseSubmit
            />
            <PageModal
                size='L'
                isOpen
                title='เลือกใช้งานเทมเพลต'
                handleClose={() => {
                    setTemplateList([])
                    setDiagnosisList([])
                    props.setIsOpenModal(false)
                }}
                onCancel={{
                    onClick: () => {
                        setTemplateList([])
                        setDiagnosisList([])
                        props.setIsOpenModal(false)
                    }
                }}
                onSubmit={{ onClick: () => onSubmit(), title: 'ใช้เทมเพลตที่เลือก', width: 150 }}
                overflow
            >
                <Box>
                    <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="16px">
                        <Typography sx={{ color: colors.themeMainColor, fontWeight: 600 }}>{t(`ประเภทเทมเพลต`)}</Typography>
                        <Box width="100%" sx={{ maxWidth: 379 }}>
                            <TextInput
                                label={t('ค้นหา ชื่อและรหัสเทมเพลต')}
                                value={searchSelectTemplate}
                                onChange={(event) => {
                                    setSearchSelectTemplate(event.target.value)
                                }}
                                fullWidth
                                inputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end" >
                                            {!searchSelectTemplate ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                                <FontAwesomeIcon
                                                    icon={faTimes}
                                                    onClick={() => {
                                                        setSearchSelectTemplate('');
                                                    }}
                                                    style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                    </Box>
                    <NavBtn className="d-flex flex-wrap custom-scroll" style={{ maxHeight: '76px' }}>
                        <Box className="px-1 pb-2">
                            <ButtonType variant="outlined" title={t('TREATMENTS_DX.TITLE.ALL')} className={`${typeSelected === 'All' ? 'active' : ''} overflow-hidden`} data-value={'All'} onClick={handleChangeType} key={`btn-operativeTypes-all`}>
                                <span className="text-ellipsis">{t('TREATMENTS_DX.TITLE.ALL')}</span>
                            </ButtonType>
                        </Box>
                        <Box className="px-1 pb-2">
                            <ButtonType variant="outlined" title={t('BOOKMARK')} className={`${typeSelected === 'BOOKMARK' ? 'active' : ''}`} data-value={'BOOKMARK'} onClick={handleChangeType} key={`btn-operativeTypes-bookmark`}>
                                {isBookmark === '1' ? <Icons.StarActive fill={colors.white} /> : <Icons.StarInActive fill={colors.textPrimary} />}
                            </ButtonType>
                        </Box>
                        {
                            treatmentTemplateType.map((val: any, i: number) => {
                                return (
                                    <Box key={`col-operative-typ-${val.treatmentTemplateTypeId}`} className="px-1 pb-2">
                                        <ButtonType variant="outlined" key={val.treatmentTemplateTypeId} title={val.treatmentTemplateTypeName} data-value={val.treatmentTemplateTypeId} onClick={handleChangeType} className={`${typeSelected === val.treatmentTemplateTypeId.toString() ? 'active' : ''} text-ellipsis`}>
                                            <span className="text-ellipsis">{val.treatmentTemplateTypeName}</span>
                                        </ButtonType>
                                    </Box>
                                )
                            })
                        }
                    </NavBtn >
                    {loading ?
                        <Box height={250} display="flex" justifyContent="center" alignItems="center" fontSize={20}>
                            กำลังโหลดข้อมูล...
                        </Box>
                        :
                        <>
                            {treatmentTemplate?.length === 0 ?
                                <Box display="flex" height={250} justifyContent="center" alignItems="center" fontSize={20}>
                                    ไม่พบข้อมูล
                                </Box> :
                                <Grid container spacing={2} sx={{ height: '250px', overflowY: 'scroll', marginTop: '16px', marginBottom: '8px', alignContent: 'flex-start' }}>
                                    {_.map(treatmentTemplate, (val: any, index: number) => {

                                        const isChecked = checkedTemplates.includes(val.treatmentTemplateId)
                                        return (
                                            <Grid key={index} item sm={12} md={6} xl={4}>
                                                <CardInfo>
                                                    <div className={'d-flex align-items-center'}>
                                                        <Detail className="">
                                                            <InputCheckbox
                                                                value={val.treatmentTemplateId}
                                                                disabled={!isChecked && checkedTemplates.length >= 10}
                                                                checked={isChecked}
                                                                onChange={async (event) => {
                                                                    const checked = event.target.checked;

                                                                    if (checked) {
                                                                        await TreatmentApi.findTreatmentTemplate(val.treatmentTemplateId).then((resp) => {
                                                                            setCheckedTemplates((prev: any) => [...prev, resp.data?.treatmentTemplateId]);
                                                                            // แยก items ตาม type
                                                                            const diagnosisItems =
                                                                                resp.data?.treatmentTemplateItems
                                                                                    ?.filter((item: any) => item.type === "DIAGNOSIS")
                                                                                    .map((item: any) => ({
                                                                                        ...item,
                                                                                        diagnosisId: item?.itemId,
                                                                                        templateName: resp.data?.treatmentTemplateName,
                                                                                        doctorId: _.find(doctors, { userId: user?.userId })?.userId
                                                                                    })) || [];
                                                                            const otherItems =
                                                                                resp.data?.treatmentTemplateItems
                                                                                    ?.filter((item: any) => item.type !== "DIAGNOSIS")
                                                                                    .map((item: any) => {
                                                                                        // const price = item.price ?? 0;
                                                                                        const qty = item.qty ?? 0;
                                                                                        return {
                                                                                            ...item,
                                                                                            additional: 0,
                                                                                            additionalUnit: "BAHT",
                                                                                            approvalItems: null,
                                                                                            cfAmount: 0,
                                                                                            cfAmountNet: 0,
                                                                                            cfDiscountAmount: 0,
                                                                                            cfDiscountUnit: "BAHT",
                                                                                            cfPromotionDiscountAmount: 0,
                                                                                            cfPromotionDiscountUnit: "BAHT",
                                                                                            cfVoucherDiscountAmount: 0,
                                                                                            cfVoucherDiscountUnit: "BAHT",
                                                                                            clinicFeeId: null,
                                                                                            clinicFeeName: null,
                                                                                            clinicFeeNameEn: null,
                                                                                            clinicFeePrice: 0,
                                                                                            commission: 0,
                                                                                            dfAmount: 0,
                                                                                            dfAmountNet: 0,
                                                                                            dfDiscountAmount: 0,
                                                                                            dfDiscountUnit: "BAHT",
                                                                                            dfPromotionDiscountAmount: 0,
                                                                                            dfPromotionDiscountUnit: "BAHT",
                                                                                            dfRemark: "",
                                                                                            dfUnit: "PERCENT",
                                                                                            dfVoucherDiscountAmount: 0,
                                                                                            dfVoucherDiscountUnit: "BAHT",
                                                                                            discount: 0,
                                                                                            discountUnit: "BAHT",
                                                                                            doctorId: _.find(doctors, { userId: user?.userId })?.userId,
                                                                                            installment: null,
                                                                                            isChangeCost: "0",
                                                                                            newBodyData: "",
                                                                                            nextVisit: null,
                                                                                            note: "",
                                                                                            noteNextVisit: "",
                                                                                            operativeCode: item?.itemCode,
                                                                                            operativeId: item?.itemId,
                                                                                            price: item?.price,
                                                                                            promotion: [],
                                                                                            promotionDiscount: 0,
                                                                                            promotionDiscountUnit: "BAHT",
                                                                                            qty: item?.qty,
                                                                                            stock: item?.qtyTotal,
                                                                                            refId: 0,
                                                                                            refItemId: "",
                                                                                            refType: null,
                                                                                            requestReason: "",
                                                                                            teeth: null,
                                                                                            teethJson: null,
                                                                                            tempOrderTreatmentId: null,
                                                                                            total: qty * item?.price,
                                                                                            voucherDiscount: 0,
                                                                                            voucherDiscountUnit: "BAHT",
                                                                                            voucherListId: 0,
                                                                                            templateName: resp.data?.treatmentTemplateName,
                                                                                        };
                                                                                    }) || [];
                                                                            setTemplateList((prev: any[]) => {
                                                                                const merged = [...prev];

                                                                                otherItems.forEach((newItem: any) => {
                                                                                    const existingIndex = merged.findIndex(
                                                                                        (oldItem) => oldItem.itemId === newItem.itemId
                                                                                    );

                                                                                    if (existingIndex !== -1) {
                                                                                        // ถ้ามี itemId ซ้ำ → บวก qty และ total
                                                                                        const existingItem = merged[existingIndex];
                                                                                        const newQty = (existingItem.qty ?? 0) + (newItem.qty ?? 0);
                                                                                        merged[existingIndex] = {
                                                                                            ...existingItem,
                                                                                            qty: newQty,
                                                                                            total: newQty * (existingItem.price ?? 0),
                                                                                        };
                                                                                    } else {
                                                                                        // ถ้าไม่ซ้ำ → เพิ่มใหม่
                                                                                        merged.push(newItem);
                                                                                    }
                                                                                });
                                                                                return merged;
                                                                            });
                                                                            setDiagnosisList((prev: any[]) => {
                                                                                const merged = [...prev];
                                                                                diagnosisItems.forEach((newItem: any) => {
                                                                                    const idx = merged.findIndex((i) => i.itemId === newItem.itemId);
                                                                                    if (idx !== -1) {
                                                                                        const existing = merged[idx];
                                                                                        const newQty = (existing.qty ?? 0) + (newItem.qty ?? 0);
                                                                                        merged[idx] = { ...existing, qty: newQty };
                                                                                    } else merged.push(newItem);
                                                                                });
                                                                                return merged;
                                                                            });
                                                                        })
                                                                    } else {
                                                                        // ❌ ลบ templateId
                                                                        setCheckedTemplates((prev) => prev.filter((id) => id !== val.treatmentTemplateId));

                                                                        // ลบ items ตาม qty
                                                                        val.treatmentTemplateItems.forEach((item: any) => {
                                                                            if (item.type === "DIAGNOSIS") {
                                                                                setDiagnosisList((prev: any[]) =>
                                                                                    prev
                                                                                        .map((i) => (i.itemId === item.itemId ? { ...i, qty: (i.qty ?? 0) - (item.qty ?? 0) } : i))
                                                                                        .filter((i) => (i.qty ?? 0) > 0)
                                                                                );
                                                                            } else {
                                                                                setTemplateList((prev: any[]) =>
                                                                                    prev
                                                                                        .map((i) => (i.itemId === item.itemId ? { ...i, qty: (i.qty ?? 0) - (item.qty ?? 0), total: ((i.qty ?? 0) - (item.qty ?? 0)) * (i.price ?? 0) } : i))
                                                                                        .filter((i) => (i.qty ?? 0) > 0)
                                                                                );
                                                                            }
                                                                        });
                                                                    }
                                                                }}
                                                                className="hover-none-bg btn-select"
                                                            />
                                                        </Detail>
                                                        <Detail className="mr-auto">
                                                            <div> {val.treatmentTemplateName} </div>
                                                        </Detail>
                                                        <Detail >
                                                            <div>
                                                                <Box>
                                                                    <IconBookmark
                                                                        key={val.treatmentTemplateId}
                                                                        className="p-0 ml-1"
                                                                        onClick={() => {
                                                                            const valBuffer = val.treatmentTemplateId
                                                                            handleBookmark(valBuffer, val.bookmarkId)
                                                                        }}
                                                                        sx={{ backgroundColor: 'transparent !important' }}>
                                                                        {val.isBookmark ? (<Icons.StarActive width="24" height="24" />) : (<Icons.StarInActive width="24" height="24" />)}
                                                                    </IconBookmark>
                                                                </Box>
                                                            </div>
                                                        </Detail>
                                                        <Detail>
                                                            <IconButton
                                                                aria-label="expand row"
                                                                size="small"
                                                                className={'ml-3'}
                                                                onClick={(e) => {
                                                                    if (opens.indexOf(val.treatmentTemplateId) > -1) {
                                                                        setOpens((values: any) => [...(values || []).filter((id: number) => id !== val.treatmentTemplateId)])
                                                                    }
                                                                    else {
                                                                        setOpens((values: any) => [...(values || []), val.treatmentTemplateId])
                                                                    }
                                                                }}
                                                                style={{ transform: `${opens.length && opens.indexOf(val.treatmentTemplateId) > -1 ? 'rotate(180deg)' : 'rotate(0deg)'}` }}
                                                            >
                                                                <ExpandMoreIcon className={'expand-more'} />
                                                            </IconButton>
                                                        </Detail>
                                                    </div>
                                                    <CustomCollapse in={opens.length && opens.indexOf(val.treatmentTemplateId) > -1 ? true : false} timeout="auto" unmountOnExit>
                                                        <div className={'collapse-wrap'}>
                                                            <Typography fontSize={14} color='#808080'>
                                                                {val?.detail}
                                                            </Typography>
                                                        </div>
                                                    </CustomCollapse>
                                                </CardInfo>
                                            </Grid>
                                        )
                                    })}
                                </Grid>
                            }

                        </>

                    }
                    <Divider sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important`, marginLeft: '-8px !important', marginRight: '-8px !important', marginY: '16px' }} />
                    <Typography fontSize={18} fontWeight={500}>เทมเพลตที่เลือก</Typography>
                    <Box display="flex" flexDirection="row" alignItems="center" gap="8px" marginTop="8px" marginBottom="16px">
                        <Box
                            borderBottom={2}
                            borderColor={activeTabModal === 'TREATMENT' ? colors.themeSecondColor : colors.extraLightBlue}
                            color={activeTabModal === 'TREATMENT' ? colors.themeSecondColor : 'black'}
                            fontSize={16} height={30} width="150px" textAlign="center"
                            onClick={() => setActiveTabModal('TREATMENT')}
                            sx={{ cursor: 'pointer' }}
                        >รายการ/บริการ</Box>
                        <Box
                            borderBottom={2}
                            borderColor={activeTabModal === 'DIAGNOSIS' ? colors.themeSecondColor : colors.extraLightBlue}
                            color={activeTabModal === 'DIAGNOSIS' ? colors.themeSecondColor : 'black'}
                            fontSize={16} height={30} width="100px" textAlign="center"
                            onClick={() => setActiveTabModal('DIAGNOSIS')}
                            sx={{ cursor: 'pointer' }}
                        >คำวินิจฉัย</Box>
                    </Box>
                    {activeTabModal === "TREATMENT" &&
                        <TableCustom
                            hidePagination
                            customScroll
                            page={0}
                            pageLimit={0}
                            sortType={'ASC'}
                            sortBy={''}
                            rowCount={0}
                            textEmptyData={t('ไม่พบข้อมูล')}
                            onSort={() => {
                                return
                            }}
                            setPageLimit={() => {
                                return
                            }}
                            setPage={() => {
                                return
                            }}
                            headCells={headCellTemplate}
                            rowsData={_.map(templateList, (i, index: number) => {
                                return renderTemplate(i, index)
                            })}
                        />
                    }

                    {activeTabModal === "DIAGNOSIS" &&
                        <TableCustom
                            hidePagination
                            customScroll
                            page={0}
                            pageLimit={0}
                            sortType={'ASC'}
                            sortBy={''}
                            rowCount={0}
                            textEmptyData={t('ไม่พบข้อมูล')}
                            onSort={() => {
                                return
                            }}
                            setPageLimit={() => {
                                return
                            }}
                            setPage={() => {
                                return
                            }}
                            headCells={headCellDiagnosis}
                            rowsData={_.map(diagnosisList, (i, index: number) => {
                                return renderDiagnosis(i, index)
                            })}
                        />
                    }
                </Box>
            </PageModal>
            <Loading show={loadingPage} />
        </>
    )
}